// assets/my-model
import { getData } from 'src/services/RestApi';

export const selectAssetFileById = async (assetId) => {
  if (assetId === 0) return {};
  
  const { result, error } = await getData('api/asset/file', { assetId });
  if(error) return {};
  return result[0];
};
